import HotelFacilities from './HotelFacilities';
export default HotelFacilities;
